import { combineReducers } from "redux";
import { withProperties, getValueAtPath, optimizeMerchantLogo } from "../../utils";
import withConstantStateFactory from "../helpers/reducers/constant";
import { isWhiteLabelled } from "../../../support/helpers";

export default function state() {
  const NAME = 'merchant';
  const $state = Object.create(null);
  const { data } = this;

  const logo = getValueAtPath(data, 'merchant_logo') || null;
  const optimizedLogo = logo && logo.includes('services/filestack/download') ? optimizeMerchantLogo(logo) : logo;

  const whiteLabelled = isWhiteLabelled(getValueAtPath(data, 'currency'), getValueAtPath(data, 'country'));

  const ConstantState = withConstantStateFactory({
    name: getValueAtPath(data, 'merchant_name'),
    logo: optimizedLogo,
    poweredby: whiteLabelled ? null : 'Flutterwave' // getValueAtPath(data, 'powered_by')
  });

  const Reducer = combineReducers({
    ...ConstantState
  });

  // Augment $state with properties
  withProperties($state, { NAME, Reducer });

  return (state = $state);
}
